// Quem é consultor do pipeline e quem é admin do painel é decidido pelo SERVIDOR
// (PIPELINE_CONSULTOR_EMAILS / PAINEL_ADMIN_EMAILS, que vêm de env). O login
// devolve os dois flags no `user`.
//
// As listas abaixo são só FALLBACK para sessão antiga (token emitido antes dos
// flags existirem). Não são a verdade: em produção a env já tem ic@ e jv@ que
// elas não conhecem — foi assim que o ic@ ficou sem o "ver como consultor".
const FALLBACK_CONSULTORES = new Set([
  'vs@caremfo.com',
  'pl@caremfo.com',
  'mr@caremfo.com',
]);
const FALLBACK_ADMINS = new Set([
  'mk@caremfo.com', 'jv@caremfo.com', 'cl@caremfo.com', 'mh@caremfo.com',
]);

const emailDe = (u) => (typeof u === 'string' ? u : u?.email || '').toLowerCase();

// Admin do painel. Aceita o objeto user (preferido) ou o e-mail cru (fallback).
export const isAdmin = (u) => (typeof u?.is_painel_admin === 'boolean'
  ? u.is_painel_admin
  : FALLBACK_ADMINS.has(emailDe(u)));

const ehConsultorPipeline = (u) => (typeof u?.is_pipeline_consultor === 'boolean'
  ? u.is_pipeline_consultor
  : FALLBACK_CONSULTORES.has(emailDe(u)));

// true quando o usuário só deve ver a página Minha Semana (e nada mais do painel).
// Admin do painel NUNCA é pipeline-only, mesmo estando na allowlist de consultores
// — em prod o jv@ está nas duas listas, e prendê-lo no formulário tiraria dele o
// dashboard inteiro.
export const isPipelineOnly = (u) => ehConsultorPipeline(u) && !isAdmin(u);
